import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
// import { Quasar } from 'quasar'; .use(Quasar, { /* config */ })
import { createPinia } from 'pinia';
import { useUserStore } from './stores/user';
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

// 忽略浏览器 ResizeObserver 无害提示，避免开发服全屏红字遮罩
const isResizeObserverNoise = (msg: unknown) =>
  typeof msg === 'string' && msg.includes('ResizeObserver loop')
window.addEventListener('error', (e) => {
  if (isResizeObserverNoise(e.message)) {
    e.stopImmediatePropagation()
  }
})
window.addEventListener('unhandledrejection', (e) => {
  const msg = e.reason && (e.reason.message || String(e.reason))
  if (isResizeObserverNoise(msg)) {
    e.preventDefault()
  }
})

const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.use(createPinia()).use(ElementPlus, {
    locale: zhCn,
  }).use(router).mount('#app')
// 初始化用户状态
const userStore = useUserStore();
// // 检查默认登录状态
// if (localStorage.getItem('defaultToken')) {
//   userStore.login('default');
// }

// 检查群组管理登录状态
if (localStorage.getItem('guaranteeToken')) {
  userStore.login('guarantee');
}
if (localStorage.getItem('shoppingManageToken')) {
  userStore.login('shoppingManage');
}
if (localStorage.getItem('groupManageToken')) {
  userStore.login('groupManage');
}
if (localStorage.getItem('upgradeToken')) {
  userStore.login('upgrade');
}